import { ScreenLayout } from '@/components/shared/ScreenLayout';
import { Button } from '@/components/ui/Button';
import { getMaxBridge } from '@/lib/max-bridge';

/**
 * Экран «Откройте тест из сообщения в чате».
 *
 * Показывается когда родитель открыл Mini App без валидного start_param —
 * чаще всего это системная кнопка «Открыть» в настройках бота, которая
 * запускает Mini App без deeplink-параметра. Welcome message с inline-
 * кнопкой «Пройти тест» (доставляется webhook-driven worker) ещё мог не
 * прийти, или родитель его пропустил.
 *
 * Дизайн: лаконичный — один заголовок + одно объяснение + одна кнопка
 * «Закрыть» (getMaxBridge().close()). Никаких CTA на test (без
 * валидного city не можем создать лид) и никаких упоминаний школы /
 * менеджера (тестовый поток через бота, не школа напрямую).
 *
 * Гарантии:
 *  - state.city === null → AppShell редиректит сюда (см. App.tsx).
 *  - На этом экране лид не создаётся, никаких submit'ов.
 */
export default function InvalidLink() {
  const handleClose = () => {
    try {
      getMaxBridge().close();
    } catch {
      // Bridge может не быть инициализирован (тестовое окружение / dev).
      if (typeof window !== 'undefined') {
        window.close();
      }
    }
  };

  return (
    <ScreenLayout
      hideHeader
      cta={
        <Button onClick={handleClose} fullWidth>
          Закрыть
        </Button>
      }
    >
      <div className="flex flex-col gap-4 pt-8">
        <h1 className="text-2xl font-bold leading-tight text-text-primary">
          Тест нужно открыть из сообщения в чате
        </h1>
        <p className="text-base leading-relaxed text-text-secondary">
          Вернитесь в чат с ботом «АйТи-Профиль» и нажмите кнопку «Пройти тест» в сообщении.
        </p>
        <p className="text-base leading-relaxed text-text-secondary">
          Сообщение может появиться не сразу. Обычно это занимает несколько секунд.
        </p>
      </div>
    </ScreenLayout>
  );
}
